import { Button } from 'antd';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import holderImg from '@/assets/images/public/empty-config.svg';
import {
  isAndroid,
  isIOS,
  isFlutter,
  isWindows,
  isVisionOS,
  isHarmonyOS,
  isMac,
  isAppleTV,
} from '@/infrastructure/product-info';
import { ConfigTabType } from '@/presentation/pages/setting/app-deliver-config/api';
import { EditConfigModal, OperationType } from '@/presentation/pages/setting/app-deliver-config/config-modal/edit';
import style from './index.module.scss';

export const ConfigEmpty: FC<{
  tab: ConfigTabType;
  update: () => void;
  defaultConfig: string;
  configDocUrl?: string;
}> = (props) => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { tab, update, defaultConfig } = props;

  const addNewConfig = () => {
    setIsModalVisible(true);
  };

  const onAddNewConfig = () => {
    setIsModalVisible(false);
    update();
  };

  const emtpyText = !(
    isAndroid()
    || isIOS()
    || isAppleTV()
    || isVisionOS()
    || isFlutter()
    || isHarmonyOS()
    || isMac()
    || (isWindows() && tab === ConfigTabType.BUSINESS)
  ) ? (
      t('很抱歉，该平台暂不支持SDK配置哦～')
    ) : (
    <div>
      {t('您还没有创建配置，')}
      <Button type="link" onClick={addNewConfig} className={style.emptyBtn}>
        <div className={style.emptyBtnText}>{t('点击快速创建')}</div>
      </Button>
      {t('一个吧～')}
    </div>
    );

  return (
    <div className={style.emptyContent}>
      <img src={holderImg}  alt={''}/>
      <div className={style.emptyText}>
        {emtpyText}
      </div>
      <EditConfigModal
        visible={isModalVisible}
        type={OperationType.ADD}
        tab={tab}
        onChange={onAddNewConfig}
        onCancel={() => setIsModalVisible(false)}
        defaultConfig={defaultConfig}
      />
    </div>
  );
};
